import { useContext } from 'react';
import { AppComponentsContext } from '../contexts';
export function useAppComponents() {
    const components = useContext(AppComponentsContext);
    if (!components) {
        throw new Error('AppComponent used without AppComponentsProvider!');
    }
    return components;
}
